// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"5":"cda109cd","11":"141a941e","131":"5f788d6d","219":"53e519e7","357":"1f450125","538":"6cc45667","680":"e2f47589","763":"0392d9b4","974":"4cd94b81"}[chunkId] + ".chunk.js";
};